module.exports = __webpack_public_path__ + "static/media/3.f5ae14ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/03/projects/01/3.jpg
// module id = 410
// module chunks = 0